// Canonical survey enums. Source of truth for the web form, the Fastify API,
// and the Prisma schema.
//
// Keep this file in sync with the form in apps/web/src/survey — the copy in
// each <option> / <input value="..."> MUST match one of these string values.
//
// Request/response zod schemas live next door in ./schemas.ts.
export const CurrentBucket = {
    STEPPED_AWAY: "STEPPED_AWAY",
    REC_READY_MORE: "REC_READY_MORE",
    NEW_TO_SPORTS: "NEW_TO_SPORTS",
    OTHER: "OTHER",
};
export const Reason = {
    LOWER_PRESSURE: "LOWER_PRESSURE",
    MORE_FUN: "MORE_FUN",
    MULTI_SPORT: "MULTI_SPORT",
    QUALITY_COACHING: "QUALITY_COACHING",
    SCHEDULE: "SCHEDULE",
    SIBLING: "SIBLING",
    PRICE: "PRICE",
};
export const PriceSentiment = {
    GREAT_DEAL: "GREAT_DEAL",
    FAIR: "FAIR",
    EXPENSIVE_BUT_CONSIDER: "EXPENSIVE_BUT_CONSIDER",
    TOO_EXPENSIVE: "TOO_EXPENSIVE",
};
export const SiblingImpact = {
    YES_MEANINGFUL: "YES_MEANINGFUL",
    NOT_REALLY: "NOT_REALLY",
    ONE_KID: "ONE_KID",
};
export const SeasonLength = {
    FULL_YEAR: "FULL_YEAR",
    SCHOOL_YEAR: "SCHOOL_YEAR",
    HALF_YEAR: "HALF_YEAR",
};
export const City = {
    EAGLE_MOUNTAIN: "EAGLE_MOUNTAIN",
    SARATOGA_SPRINGS: "SARATOGA_SPRINGS",
    LEHI: "LEHI",
    OTHER: "OTHER",
};
export const AgeBand = {
    SEVEN_TO_NINE: "SEVEN_TO_NINE",
    TEN_TO_ELEVEN: "TEN_TO_ELEVEN",
    TWELVE_TO_THIRTEEN: "TWELVE_TO_THIRTEEN",
};
export const Gender = {
    MALE: "MALE",
    FEMALE: "FEMALE",
    NON_BINARY: "NON_BINARY",
    PREFER_NOT_TO_SAY: "PREFER_NOT_TO_SAY",
};
export const MAX_REASONS = 3;
export const MAX_ATHLETES = 4;
